function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.143 1H2.57157C2.26846 1 1.97777 1.12041 1.76345 1.33474C1.54912 1.54906 1.42871 1.83975 1.42871 2.14286V11.2857C1.42871 11.5888 1.54912 11.8795 1.76345 12.0938C1.97777 12.3082 2.26846 12.4286 2.57157 12.4286H9.42871C9.73182 12.4286 10.0225 12.3082 10.2368 12.0938C10.4512 11.8795 10.5716 11.5888 10.5716 11.2857V4.42857M7.143 1L10.5716 4.42857M7.143 1V4.42857H10.5716M8.28585 7.28571H3.71443M8.28585 9.57143H3.71443M4.85728 5H3.71443",
  stroke: "#FEFFFE",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgFileButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileButton);
export default __webpack_public_path__ + "static/media/file-button.09d7b28b.svg";
export { ForwardRef as ReactComponent };